import routerMaps from './routerMap';
import notInMenuRoute from '@/layout/model/notInMenuRoute';

import MainMenus from '@/layout/model/mainMenu';

const constantRouterMap = [...routerMaps];
let flattenedRoutes = []
let flattenedMenus = {};

const getMenus = async (cb) => { // 获取菜单 不处理返回  按菜单去添加路由对象
  try {
    const url = '/auth/menus/findByParentID';
    const res = await eBase.send({
      url,
      params: {
        // type: '0',
      },
    }, 'post');
    if (!res.data) { // error
      cb(res);
      return {};
    }
    return res;
  } catch (e) {
    console.warn(e.message);
  }
}

function __formatMenuFields(menus, parent = {}) { // 格式化字段 添加parent属性 后面处理详情路由
  menus.forEach((item) => {
    if(!item.label){
      (item.label = item.name, item.icon = item.iconCls);
    }
    if (Object.keys(parent).length) {
      item.parent = {
        label: parent.name,
        url: parent.url
      };
    }
    item.children && item.children[0] && __formatMenuFields(item.children, item);
  });
  return menus;
}

function __addOnelevelMenuType(menus = []) { // 一级菜单添加type属性
  return menus[0] ? menus.map(item => ({ ...item,
    type: '1'
  })) : [];
}

const flattenRoutes = (maps) => { // 所有路由对象flatten到flattenedRoutes 方便搜索
  maps.forEach(item => {
    flattenedRoutes.push(item)
    if (item.children) {
      flattenRoutes(item.children)
    }
  })
}

const flattenMenus = (menus) => {
  menus.forEach(item => {
    flattenedMenus[item.url] = item;
    if (item.children) {
      flattenMenus(item.children)
    }else{
      item.children = [];
    }
  })
}

export const initMenuRoutes = async (cb) => {
  let res = await getMenus(cb);
  res = res.data;
  res.data = res.restluLis;
  // const res = MainMenus;
  let menus = [];
  let typeMenus = [];
  try {
    menus = __addOnelevelMenuType(res.data);
    typeMenus = __formatMenuFields(menus);
  } catch (e) {
    console.warn(e.message);
  }

  sessionStorage.menus = JSON.stringify(typeMenus);

  let r = [{
    path: '/',
    component: () => import('@/layout/MainLayout.vue'),
    children: []
  }];

  r.push({
    path: '*',
    name: 'notfount',
    component: {
      template: '<div>404</div>',
    },
  })

  flattenMenus(typeMenus);
  resolveMenus(typeMenus, notInMenuRoute);
  const ls = resolveRoutes(typeMenus);
  const deep0Redirect = (arr) => {
    if (!arr[0]) return
    arr[0].children && arr[0].children[0] ? deep0Redirect(arr[0].children) : (r[0].redirect = {
      path: arr[0].path
    })
  }
  deep0Redirect(ls);
  r[0].children = ls;

  // r[0].children = r[0].children.concat(constantRouterMap);

  return r
}

const resolveMenus = (menus, extraMenus) => { // 合并menu
  menus.forEach(item => {
    if (!item.children || !item.children[0]) {
      let tempArr;
      if (tempArr = extraMenus.filter(item1 => item1.linkParent.url == item.url)) {
        tempArr[0] && tempArr.forEach(item2 => {
          let realParent
          if(!item2.linkRoute){
            realParent = flattenedMenus[flattenedMenus[item2.linkParent.url].parent.url];
          }else{
            realParent = flattenedMenus[flattenedMenus[item2.linkParent.url].parent.url].children.find(item=>item.url == item2.linkRoute.url);
          }
          if(!realParent.children) realParent.children = [];
          realParent.children.push(item2);
        })
        // console.log(flattenedMenus[temp.linkParent.url])
      }
    } else {
      resolveMenus(item.children, extraMenus)
    }
  })

}

const resolveRoutes = (menus) => { // 将菜单处理成routes
  return menus.map(item => {
    const l = flattenedRoutes.find(litem => litem.path == item.url);
    const {url, component, children} = item;
    return {
      ...l,
      path: url,
      component: l ? l.component : {
        template: "<router-view></router-view>"
      },
      children: item.children ? resolveRoutes(item.children) : []
    }
  })
}

flattenRoutes(constantRouterMap);



// WEBPACK FOOTER //
// ./src/router/mixin.js